import { defineStore } from 'pinia'

const STORAGE_KEY = 'selected_stock'

const readStoredStock = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    // A hand-edited or half-written localStorage value must not take the
    // dashboard down on boot -- fall back to "no stock filter".
    return null
  }
}

export const stockStore = defineStore({
  id: 'stock',
  state: () => ({
    // null = no stock filter, i.e. the dashboard shows the whole portfolio for
    // whatever platforms are selected. The whole {stock_id, name, code} row is
    // kept (not just the id) so the navbar can label the active filter without
    // waiting on the stock list to load.
    selectedStock: readStoredStock(),
  }),
  actions: {
    setStock(stock) {
      const value = stock
        ? { stock_id: stock.stock_id, name: stock.name, code: stock.code }
        : null

      if (value) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }

      this.selectedStock = value
    },
    clearStock() {
      this.setStock(null)
    },
  },
})
